// extracted by mini-css-extract-plugin
module.exports = {"paginator":"Paginator_paginator__dXyXB","changePageBtn":"Paginator_changePageBtn__2Hk-3","pageNumber":"Paginator_pageNumber__qwVOG","selected":"Paginator_selected__1byaM"};